import React from 'react';
import Row from '../../../../shared/components/Row';
import FormField from '../../../../shared/components/FormField';
import { Field, reduxForm } from 'redux-form';
import DateUtils from '../../../../shared/utils/DateUtils';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import PropTypes from 'prop-types';
import { NotificationExportRequest } from '../../shared/notificationExport/NotificationExportRequest';
import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../../../shared/utils/CookiesManager';
import Alert from 'react-s-alert';
import { DateFormatter } from '../../../../shared/formatters/DateFormatter';
import { DatetimeParsers } from '../../../../shared/utils/DatetimeParsers';

const FORM = {
    NAME: 'HeaderFilterNotificationOptionsForm',
    FIELDS: {
        LISTERIA_DATE_FROM: 'listeria_date_from',
        LISTERIA_DATE_TO: 'listeria_date_to',
    },
};

let HeaderFilterNotificationOptions = (props) => {

    const renderField = (field) => <FormField field={field}/>;

    const onSubmit = (values) => {
        exportNotifications(values);
    };

    const exportNotifications = (values) => {
        const { page, search, filter } = props;
        const request = new NotificationExportRequest();
        const deformatStartDate = values[FORM.FIELDS.LISTERIA_DATE_FROM] ? DateFormatter.deformat(values[FORM.FIELDS.LISTERIA_DATE_FROM]) : null;
        const deformatEndDate = values[FORM.FIELDS.LISTERIA_DATE_TO] ? DateFormatter.deformat(values[FORM.FIELDS.LISTERIA_DATE_TO]) : null;
        const startDate = DatetimeParsers.parseInputDateToISODate(deformatStartDate);
        const endDate = DatetimeParsers.parseInputDateToISODate(deformatEndDate);

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);
        request.setListeriaDateFrom(startDate);
        request.setListeriaDateTo(endDate);
        // request.setDateFrom(startDate);
        // request.setDateTo(endDate);

        const genericRequest = new GenericRequest(METHOD_POST, ApiEndpoints.NOTIFICATIONS_EXPORT);
        let headers = genericRequest.headers;
        const authToken = cookie.load(AUTH_TOKEN);
        if (authToken) {
            headers.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }
        const requestInit = {
            method: genericRequest.method,
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(request.body()),
        };

        fetch(genericRequest.url, requestInit)
            .then(response => {
                response.blob().then(function (myBlob) {
                    const url = URL.createObjectURL(myBlob);
                    window.open(url, '_blank');
                });
            })
            .catch(error => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_AL_EXPORTAR_EL_CSV'));
            });
    };

    return (
        <form onSubmit={props.handleSubmit(onSubmit)}>
            <Row>
                <Field
                    label={I18nUtils.tr('TR_FECHA_INICIO')}
                    placeholder={I18nUtils.tr('TR_FECHA_INICIO')}
                    name={FORM.FIELDS.LISTERIA_DATE_FROM}
                    type={'date'}
                    colWidth="col-sm-5"
                    component={renderField}
                />
                <Field
                    label={I18nUtils.tr('TR_FECHA_FIN')}
                    placeholder={I18nUtils.tr('TR_FECHA_FIN')}
                    name={FORM.FIELDS.LISTERIA_DATE_TO}
                    type={'date'}
                    colWidth="col-sm-5"
                    component={renderField}
                />
                <Field
                    label={I18nUtils.tr('TR_EXPORTAR').toUpperCase()}
                    name="submit"
                    type={'submit'}
                    colWidth="col-md-2"
                    component={renderField}
                />
            </Row>
        </form>
    );
};

const validate = (values) => {
    const errors = {};

    if ( !DateUtils.isValidDate(values[FORM.FIELDS.LISTERIA_DATE_FROM]) ) {
        errors[FORM.FIELDS.LISTERIA_DATE_FROM] = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( !DateUtils.isValidDate(values[FORM.FIELDS.LISTERIA_DATE_TO]) ) {
        errors[FORM.FIELDS.LISTERIA_DATE_TO] = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( DateUtils.isValidDate(values[FORM.FIELDS.LISTERIA_DATE_FROM]) && DateUtils.isValidDate(values[FORM.FIELDS.LISTERIA_DATE_TO]) ) {
        let startDate = values[FORM.FIELDS.LISTERIA_DATE_FROM];
        if ( typeof startDate === 'string' ) {
            startDate = DateUtils.buildDateFromString(startDate);
        }
        let endDate = values[FORM.FIELDS.LISTERIA_DATE_TO];
        if ( typeof endDate === 'string' ) {
            endDate = DateUtils.buildDateFromString(endDate);
        }

        if ( startDate > endDate ) {
            errors[FORM.FIELDS.LISTERIA_DATE_FROM] = I18nUtils.tr('TR_FECHA_INICIO_NO_PUEDE_SER_MAYOR_QUE_FIN');
        }
    }

    return errors;
};

HeaderFilterNotificationOptions = reduxForm({
    validate,
    form: FORM.NAME,
})(HeaderFilterNotificationOptions);

export default HeaderFilterNotificationOptions;

HeaderFilterNotificationOptions.propTypes = {
    search: PropTypes.string,
    page: PropTypes.number,
    filter: PropTypes.any,
};




// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/component/HeaderFilterNotificationOptions.jsx